// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3WIpK","ranges":"BmiRanges_ranges__3fDaA"};